// settings selected by the user
export class UserSettings {
  public showGuidance: boolean = true;
}
